import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "d-flex align-center justify-space-between" }
const _hoisted_2 = ["onDragstart", "onDrop", "onClick"]
const _hoisted_3 = { class: "d-flex align-center justify-space-between" }
const _hoisted_4 = { class: "d-flex align-center justify-center ga-2 px-2" }
const _hoisted_5 = { class: "value-label" }
const _hoisted_6 = { class: "d-flex align-center justify-center ga-2 px-2" }
const _hoisted_7 = { class: "value-label" }
const _hoisted_8 = { class: "d-flex align-center justify-center ga-2 px-2" }
const _hoisted_9 = { class: "value-label" }
const _hoisted_10 = { class: "d-flex align-center justify-center ga-2 px-2" }
const _hoisted_11 = { class: "value-label" }
const _hoisted_12 = { class: "d-flex align-center justify-center ga-2 px-2" }
const _hoisted_13 = { class: "value-label" }
const _hoisted_14 = { class: "d-flex align-center justify-space-between" }
const _hoisted_15 = ["onDragstart", "onDrop", "onClick"]
const _hoisted_16 = { class: "d-flex align-center justify-space-between" }
const _hoisted_17 = { class: "d-flex align-center justify-center ga-2 px-2" }
const _hoisted_18 = { class: "value-label" }
const _hoisted_19 = { class: "d-flex align-center justify-center ga-2 px-2" }
const _hoisted_20 = { class: "value-label" }
const _hoisted_21 = { class: "d-flex align-center justify-center ga-2 px-2" }
const _hoisted_22 = { class: "value-label" }
const _hoisted_23 = { class: "d-flex align-center justify-center ga-2 px-2" }
const _hoisted_24 = { class: "value-label" }
const _hoisted_25 = { class: "d-flex align-center justify-space-between" }
const _hoisted_26 = ["onDragstart", "onDrop", "onClick"]
const _hoisted_27 = { class: "d-flex align-center justify-space-between" }
const _hoisted_28 = { class: "d-flex align-center justify-center ga-2 px-2" }
const _hoisted_29 = { class: "value-label" }
const _hoisted_30 = { class: "d-flex align-center justify-center ga-2 px-2" }
const _hoisted_31 = { class: "value-label" }
const _hoisted_32 = { class: "d-flex align-center justify-center ga-2 px-2" }
const _hoisted_33 = { class: "value-label" }
const _hoisted_34 = { class: "d-flex align-center justify-center ga-2 px-2" }
const _hoisted_35 = { class: "value-label" }

import { ref, onMounted, onUnmounted } from "vue";

/********************************
 ********** CONSTANTES **********
 *******************************/
import { LABELS } from "@/constants/labels";
import { COLOR } from "@/constants/colors";

/********************************
 *********** SERVICES ***********
 *******************************/
import {
  getAllLatencyData,
  getAllQualityData,
  getAllRajantData,
  getAllSensoresData,
} from "@/services/Smartlink/KPI";

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import DialogComponent from "@/components/SmartLink/dialog/dialogComponent.vue";

// FUNCIONES DE COLORES

export default /*@__PURE__*/_defineComponent({
  __name: 'KPIView',
  setup(__props) {

const store = useStore();

/********************************
 ************ I18N **************
 *******************************/
const { t } = useI18n();

/********************************
 ********** COMPONENTES *********
 *******************************/
function getVoltajeColor(voltaje: number): string {
  if (voltaje < 5000 && voltaje > 0) return COLOR.green;
  if (voltaje >= 5000 && voltaje < 10000) return COLOR.yellow;
  if (voltaje >= 10000) return COLOR.red;
  return COLOR.grey;
}

function getTemperatureColor(temperature: number): string {
  if (temperature <= 30) return COLOR.green;
  if (temperature > 30 && temperature <= 60) return COLOR.yellow;
  if (temperature > 60 && temperature <= 70) return COLOR.warning;
  return COLOR.red;
}

function getCostColor(cost: number): string {
  if (cost < 5000) return COLOR.green;
  if (cost >= 5000 && cost < 10000) return COLOR.yellow;
  return COLOR.red;
}

function getLatencyColor(latency: number): string {
  if (latency < 100 && latency >= 0) return COLOR.green;
  if (latency >= 100 && latency < 200) return COLOR.yellow;
  if (latency >= 200) return COLOR.red;
  return COLOR.grey;
}

function getSNRColor(snr: number): string {
  if (snr < 16 && snr >= 0) return COLOR.red;
  if (snr >= 16 && snr < 20) return COLOR.yellow;
  if (snr >= 20) return COLOR.green;
  return COLOR.grey;
}

function getRXColor(rx: number): string {
  if (rx < 0 && rx >= -65) return COLOR.green;
  if (rx >= -75 && rx < -65) return COLOR.yellow;
  if (rx < -75) return COLOR.red;
  return COLOR.grey;
}

// BÚSQUEDAS
const searchDistribucion = ref("");
const searchAcceso = ref("");
const searchClient = ref("");

// ENCABEZADOS INDEPENDIENTES PARA PERMITIR ARRASTRAR DE FORMA INDIVIDUAL
const headersAcceso = ref([
  { key: "name", title: t("labels.equipment"), sortable: true },
  { key: "ip", title: "IP", sortable: true },
  { key: "tipo", title: `${t("labels.type")}`, sortable: true },
  { key: "latencia", title: `${t("labels.latency")} (ms)`, sortable: true },
  { key: "cost", title: t("labels.cost"), sortable: true },
  { key: "temperatura", title: `${t("labels.temperature")} (°C)`, sortable: true },
  { key: "voltaje", title: `${t("labels.voltage")} (Volt)`, sortable: true },
]);

const headersCliente = ref([
  { key: "name", title: t("labels.equipment"), sortable: true },
  { key: "ip", title: "IP", sortable: true },
  { key: "tipo", title: `${t("labels.type")}`, sortable: true },
  { key: "latencia", title: `${t("labels.latency")} (ms)`, sortable: true },
  { key: "cost", title: t("labels.cost"), sortable: true },
  { key: "temperatura", title: `${t("labels.temperature")} (°C)`, sortable: true },
  { key: "voltaje", title: `${t("labels.voltage")} (Volt)`, sortable: true },
]);

const headersDistribucion = ref([
  { key: "name", title: t("labels.equipment"), sortable: true },
  { key: "ip", title: "IP", sortable: true },
  { key: "tipo", title: `${t("labels.type")}`, sortable: true },
  { key: "latencia", title: `${t("labels.latency")} (ms)`, sortable: true },
  { key: "snr_v", title: `${t("labels.snrVerti")} (dB)`, sortable: true },
  { key: "snr_h", title: `${t("labels.snrHoriz")} (dB)`, sortable: true },
  { key: "rxh", title: `${t("labels.rxHoriz")} (dBm)`, sortable: true },
  { key: "rxv", title: `${t("labels.rxVerti")} (dBm)`, sortable: true },
]);

// ESTADOS DRAG & DROP
const draggedIndex = ref<number | null>(null);

function onDragStart(index: number) {
  draggedIndex.value = index;
}

function onDrop(targetIndex: number, headersArray: any[]) {
  if (draggedIndex.value === null || draggedIndex.value === targetIndex) return;
  const movedHeader = headersArray.splice(draggedIndex.value, 1)[0];
  headersArray.splice(targetIndex, 0, movedHeader);
  draggedIndex.value = null;
}

// ESTADOS DE DATOS
const latencyItems = ref<any[]>([]);
const costItems = ref<any[]>([]);
const sensoresItems = ref<any[]>([]);
const qualityItems = ref<any[]>([]);
const finalItemsDistri = ref<any[]>([]);
const finalItemsAcceso = ref<any[]>([]);
const finalItemsClient = ref<any[]>([]);

const loading = ref(false);
let refreshInterval: ReturnType<typeof setInterval> | null = null;

async function getDataLatencyTable() {
  const allData = await getAllLatencyData();
  if (allData.status === 400) {
    store.commit("showSnackBar", {
      type: LABELS.error,
      msg: t("snackbar.errorApis"),
      valor: true,
    });
  }
  if (allData.status === 200) {
    latencyItems.value = allData.data;
  }
}

async function getDataCostTable() {
  const allData = await getAllRajantData();
  if (allData.status === 400) {
    store.commit("showSnackBar", {
      type: LABELS.error,
      msg: t("snackbar.errorApis"),
      valor: true,
    });
  }
  if (allData.status === 200) {
    costItems.value = allData.data;
  }
}

async function getDataSensoresTable() {
  const allData = await getAllSensoresData();
  if (allData.status === 400) {
    store.commit("showSnackBar", {
      type: LABELS.error,
      msg: t("snackbar.errorApis"),
      valor: true,
    });
  }
  if (allData.status === 200) {
    sensoresItems.value = allData.data;
  }
}

async function getDataQualityTable() {
  const allData = await getAllQualityData();
  if (allData.status === 400) {
    store.commit("showSnackBar", {
      type: LABELS.error,
      msg: t("snackbar.errorApis"),
      valor: true,
    });
  }
  if (allData.status === 200) {
    qualityItems.value = allData.data;
  }
}

async function combineData() {
  finalItemsDistri.value = [];
  finalItemsAcceso.value = [];
  finalItemsClient.value = [];

  latencyItems.value.forEach((item) => {
    const costItem = costItems.value[item.ip];
    const sensorItem = sensoresItems.value[item.ip];
    const qualityItem = qualityItems.value[item.ip];

    const modelo = item.anotacion ?? { model: "-" };

    const finalObj = {
      ip: item.ip,
      name: `${item.name} - ${modelo.model ?? "-"}`,
      modelo: modelo,
      tipo: item.tipo,
      latencia: item.latencia,
      cost: costItem ? costItem.cost : 0,
      temperatura: sensorItem ? sensorItem.temperatura : 0,
      voltaje: sensorItem ? sensorItem.voltaje : 0,
      snr_v: qualityItem ? qualityItem.snr_v : 0,
      snr_h: qualityItem ? qualityItem.snr_h : 0,
      avgpower: qualityItem ? qualityItem.avgpower : 0,
      rxh: qualityItem ? qualityItem.rxh : 0,
      rxv: qualityItem ? qualityItem.rxv : 0,
    };

    if (
      item.subtipo === "Distribución" ||
      item.subtipo === "Distribucion" ||
      item.subtipo === "Distribution"
    ) {
      finalItemsDistri.value.push(finalObj);
    }
    if (item.subtipo === "Acceso") {
      finalItemsAcceso.value.push(finalObj);
    }
    if (item.subtipo === "Cliente") {
      finalItemsClient.value.push(finalObj);
    }
  });
}

// PETICIÓN Y REFRESCAMIENTO DE DATOS
async function fetchAllData() {
  loading.value = true;
  await Promise.all([
    getDataLatencyTable(),
    getDataCostTable(),
    getDataSensoresTable(),
    getDataQualityTable(),
  ]);
  await combineData();
  loading.value = false;
}

// DIALOG
const dialog = ref(false);
const selectedIp = ref("");
const selectedName = ref("");
const selectedType = ref("");
const selectedModel = ref("");

function showDialog(event: any, { item }: any) {
  selectedIp.value = item.ip ?? "";
  selectedType.value = item.tipo ?? "";
  selectedName.value = item.name ?? "";
  selectedModel.value = item.model
  dialog.value = true;
}

function closeDialog() {
  dialog.value = false;
}

// CICLO DE VIDA
onMounted(async () => {
  await fetchAllData();
  // Consulta automática cada 1 minuto (60.000 ms)
  refreshInterval = setInterval(() => {
    fetchAllData();
  }, 60000);
});

onUnmounted(() => {
  if (refreshInterval) clearInterval(refreshInterval);
});

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_card, {
      flat: "",
      color: "transparent",
      class: "pa-4"
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)("labels.distribution")), 1),
          _createVNode(_component_v_btn, {
            icon: "mdi-refresh",
            density: "comfortable",
            variant: "text",
            loading: loading.value,
            onClick: fetchAllData
          }, null, 8, ["loading"])
        ])
      ]),
      text: _withCtx(() => [
        _createVNode(_component_v_text_field, {
          modelValue: searchDistribucion.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchDistribucion).value = $event)),
          label: _unref(t)('buttons.search'),
          "prepend-inner-icon": "mdi-magnify",
          variant: "outlined",
          "hide-details": "",
          "single-line": "",
          density: "compact",
          style: {"max-width":"400px"}
        }, null, 8, ["modelValue", "label"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_v_data_table, {
          headers: headersDistribucion.value,
          items: finalItemsDistri.value,
          search: searchDistribucion.value,
          loading: loading.value,
          color: "blue",
          hover: "",
          "onClick:row": showDialog
        }, {
          headers: _withCtx(({ isSorted, getSortIcon, toggleSort }) => [
            _createElementVNode("tr", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(headersDistribucion.value, (header, index) => {
                return (_openBlock(), _createElementBlock("th", {
                  key: header.key,
                  draggable: "true",
                  class: "cursor-grab header-cell",
                  onDragstart: ($event: any) => (onDragStart(index)),
                  onDragover: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
                  onDrop: ($event: any) => (onDrop(index, headersDistribucion.value)),
                  onClick: ($event: any) => (toggleSort(header))
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("span", null, _toDisplayString(header.title), 1),
                    (isSorted(header))
                      ? (_openBlock(), _createBlock(_component_v_icon, { key: 0 }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(getSortIcon(header)), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ])
                ], 40, _hoisted_2))
              }), 128))
            ])
          ]),
          "item.latencia": _withCtx(({ value }) => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(value), 1),
              _createVNode(_component_v_progress_linear, {
                "bg-color": "pink-lighten-3",
                color: getLatencyColor(value),
                "model-value": "100",
                height: "10",
                rounded: "",
                class: "flex-grow-1"
              }, null, 8, ["color"])
            ])
          ]),
          "item.snr_v": _withCtx(({ value }) => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(value), 1),
              _createVNode(_component_v_progress_linear, {
                "bg-color": "pink-lighten-3",
                color: getSNRColor(value),
                "model-value": "100",
                height: "10",
                rounded: "",
                class: "flex-grow-1"
              }, null, 8, ["color"])
            ])
          ]),
          "item.snr_h": _withCtx(({ value }) => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(value), 1),
              _createVNode(_component_v_progress_linear, {
                "bg-color": "pink-lighten-3",
                color: getSNRColor(value),
                "model-value": "100",
                height: "10",
                rounded: "",
                class: "flex-grow-1"
              }, null, 8, ["color"])
            ])
          ]),
          "item.rxh": _withCtx(({ value }) => [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, _toDisplayString(value), 1),
              _createVNode(_component_v_progress_linear, {
                "bg-color": "pink-lighten-3",
                color: getRXColor(value),
                "model-value": "100",
                height: "10",
                rounded: "",
                class: "flex-grow-1"
              }, null, 8, ["color"])
            ])
          ]),
          "item.rxv": _withCtx(({ value }) => [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", _hoisted_13, _toDisplayString(value), 1),
              _createVNode(_component_v_progress_linear, {
                "bg-color": "pink-lighten-3",
                color: getRXColor(value),
                "model-value": "100",
                height: "10",
                rounded: "",
                class: "flex-grow-1"
              }, null, 8, ["color"])
            ])
          ]),
          _: 1
        }, 8, ["headers", "items", "search", "loading"])
      ]),
      _: 1
    }),
    _createVNode(_component_v_card, {
      flat: "",
      color: "transparent",
      class: "pa-4"
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)("labels.access")), 1),
          _createVNode(_component_v_btn, {
            icon: "mdi-refresh",
            density: "comfortable",
            variant: "text",
            loading: loading.value,
            onClick: fetchAllData
          }, null, 8, ["loading"])
        ])
      ]),
      text: _withCtx(() => [
        _createVNode(_component_v_text_field, {
          modelValue: searchAcceso.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchAcceso).value = $event)),
          label: _unref(t)('buttons.search'),
          "prepend-inner-icon": "mdi-magnify",
          variant: "outlined",
          "hide-details": "",
          "single-line": "",
          density: "compact",
          style: {"max-width":"400px"}
        }, null, 8, ["modelValue", "label"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_v_data_table, {
          headers: headersAcceso.value,
          items: finalItemsAcceso.value,
          search: searchAcceso.value,
          loading: loading.value,
          color: "blue",
          hover: "",
          "onClick:row": showDialog
        }, {
          headers: _withCtx(({ isSorted, getSortIcon, toggleSort }) => [
            _createElementVNode("tr", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(headersAcceso.value, (header, index) => {
                return (_openBlock(), _createElementBlock("th", {
                  key: header.key,
                  draggable: "true",
                  class: "cursor-grab header-cell",
                  onDragstart: ($event: any) => (onDragStart(index)),
                  onDragover: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
                  onDrop: ($event: any) => (onDrop(index, headersAcceso.value)),
                  onClick: ($event: any) => (toggleSort(header))
                }, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("span", null, _toDisplayString(header.title), 1),
                    (isSorted(header))
                      ? (_openBlock(), _createBlock(_component_v_icon, { key: 0 }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(getSortIcon(header)), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ])
                ], 40, _hoisted_15))
              }), 128))
            ])
          ]),
          "item.temperatura": _withCtx(({ value }) => [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("span", _hoisted_18, _toDisplayString(value) + " °C", 1),
              _createVNode(_component_v_progress_linear, {
                "bg-color": "pink-lighten-3",
                color: getTemperatureColor(value),
                "model-value": "100",
                height: "10",
                rounded: "",
                class: "flex-grow-1"
              }, null, 8, ["color"])
            ])
          ]),
          "item.voltaje": _withCtx(({ value }) => [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("span", _hoisted_20, _toDisplayString(value) + " V", 1),
              _createVNode(_component_v_progress_linear, {
                "bg-color": "pink-lighten-3",
                color: getVoltajeColor(value),
                "model-value": "100",
                height: "10",
                rounded: "",
                class: "flex-grow-1"
              }, null, 8, ["color"])
            ])
          ]),
          "item.cost": _withCtx(({ value }) => [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("span", _hoisted_22, _toDisplayString(value), 1),
              _createVNode(_component_v_progress_linear, {
                "bg-color": "pink-lighten-3",
                color: getCostColor(value),
                "model-value": "100",
                height: "10",
                rounded: "",
                class: "flex-grow-1"
              }, null, 8, ["color"])
            ])
          ]),
          "item.latencia": _withCtx(({ value }) => [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("span", _hoisted_24, _toDisplayString(value), 1),
              _createVNode(_component_v_progress_linear, {
                "bg-color": "pink-lighten-3",
                color: getLatencyColor(value),
                "model-value": "100",
                height: "10",
                rounded: "",
                class: "flex-grow-1"
              }, null, 8, ["color"])
            ])
          ]),
          _: 1
        }, 8, ["headers", "items", "search", "loading"])
      ]),
      _: 1
    }),
    _createVNode(_component_v_card, {
      flat: "",
      color: "transparent",
      class: "pa-4"
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)("labels.client")), 1),
          _createVNode(_component_v_btn, {
            icon: "mdi-refresh",
            density: "comfortable",
            variant: "text",
            loading: loading.value,
            onClick: fetchAllData
          }, null, 8, ["loading"])
        ])
      ]),
      text: _withCtx(() => [
        _createVNode(_component_v_text_field, {
          modelValue: searchClient.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((searchClient).value = $event)),
          label: _unref(t)('buttons.search'),
          "prepend-inner-icon": "mdi-magnify",
          variant: "outlined",
          "hide-details": "",
          "single-line": "",
          density: "compact",
          style: {"max-width":"400px"}
        }, null, 8, ["modelValue", "label"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_v_data_table, {
          headers: headersCliente.value,
          items: finalItemsClient.value,
          search: searchClient.value,
          loading: loading.value,
          color: "blue",
          hover: "",
          "onClick:row": showDialog
        }, {
          headers: _withCtx(({ isSorted, getSortIcon, toggleSort }) => [
            _createElementVNode("tr", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(headersCliente.value, (header, index) => {
                return (_openBlock(), _createElementBlock("th", {
                  key: header.key,
                  draggable: "true",
                  class: "cursor-grab header-cell",
                  onDragstart: ($event: any) => (onDragStart(index)),
                  onDragover: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"])),
                  onDrop: ($event: any) => (onDrop(index, headersCliente.value)),
                  onClick: ($event: any) => (toggleSort(header))
                }, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("span", null, _toDisplayString(header.title), 1),
                    (isSorted(header))
                      ? (_openBlock(), _createBlock(_component_v_icon, { key: 0 }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(getSortIcon(header)), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ])
                ], 40, _hoisted_26))
              }), 128))
            ])
          ]),
          "item.temperatura": _withCtx(({ value }) => [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("span", _hoisted_29, _toDisplayString(value) + " °C", 1),
              _createVNode(_component_v_progress_linear, {
                "bg-color": "pink-lighten-3",
                color: getTemperatureColor(value),
                "model-value": "100",
                height: "10",
                rounded: "",
                class: "flex-grow-1"
              }, null, 8, ["color"])
            ])
          ]),
          "item.voltaje": _withCtx(({ value }) => [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("span", _hoisted_31, _toDisplayString(value) + " V", 1),
              _createVNode(_component_v_progress_linear, {
                "bg-color": "pink-lighten-3",
                color: getVoltajeColor(value),
                "model-value": "100",
                height: "10",
                rounded: "",
                class: "flex-grow-1"
              }, null, 8, ["color"])
            ])
          ]),
          "item.cost": _withCtx(({ value }) => [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("span", _hoisted_33, _toDisplayString(value), 1),
              _createVNode(_component_v_progress_linear, {
                "bg-color": "pink-lighten-3",
                color: getCostColor(value),
                "model-value": "100",
                height: "10",
                rounded: "",
                class: "flex-grow-1"
              }, null, 8, ["color"])
            ])
          ]),
          "item.latencia": _withCtx(({ value }) => [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("span", _hoisted_35, _toDisplayString(value), 1),
              _createVNode(_component_v_progress_linear, {
                "bg-color": "pink-lighten-3",
                color: getLatencyColor(value),
                "model-value": "100",
                height: "10",
                rounded: "",
                class: "flex-grow-1"
              }, null, 8, ["color"])
            ])
          ]),
          _: 1
        }, 8, ["headers", "items", "search", "loading"])
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: dialog.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((dialog).value = $event)),
      width: "85%"
    }, {
      default: _withCtx(() => [
        (dialog.value)
          ? (_openBlock(), _createBlock(DialogComponent, {
              key: 0,
              ip: selectedIp.value,
              typeSel: selectedType.value,
              name: selectedName.value,
              modelo: selectedModel.value,
              onDialog: closeDialog,
              status: 'Ok'
            }, null, 8, ["ip", "typeSel", "name", "modelo"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})